import PageTitle from "../MainContents/PageTitle/PageTitle";
import Curriculum from "./Curriculum";
import styled from 'styled-components';
import { device } from '../MainContents/Style/StyleDevice';
import ImgLesson from '../../img/child.jpg';
import ScrollToTopOnMount from '../MainContents/AutoScrollTop'; 
import LessonFlow from "./LessonFlow";
import ParentVoice from "./ParentVoice";


const Main =styled.div`
    margin-top: 100px;
    width: 90%;
    margin: auto;
    @media ${device.mobile}{
        width: 95%;
    }
`

const Mt =styled.div`
margin-top:130px;
@media ${device.mobile}{
  margin-top:80px;
  }
`

const Lesson: React.VFC = () => {
  return (
    <Main>
      <ScrollToTopOnMount />
      <Mt></Mt>
      <PageTitle title={'授業内容'} englishText={'Lesson&Content'} />
      <div className='mt-3 grid grid-cols-3  sm:grid-cols-3 md:grid-cols-6   bg-orange-400'>
        {/* <img className='col-span-3' src={ImgLesson} alt={'レッスン'} /> */}
        <div style={{background: 'whitesmoke'}}></div>
        <div className='col-span-3 text-xl font-sans p-3'>
        <div className="text-white">
            <p className="mt-3">従来の暗記中心の教育では、来るAI時代に対応できる人材を育成できないことが懸念されています。</p>
            <p className="mt-3">そこで、近年注目を集めているのがSTEAM教育です。</p>
            <p className="mt-3">STEAM教育とは、科学・技術・工学・美術・数学の５分野を横断的に学習する教育で、世界各国が国策として実施しています。</p>
            <p className="mt-3">そして、このSTEAM教育を幼児・低学年向けに行う専門スクールがSTEMON(ステモン)なのです。STEMONでは、プログラミングやロボット製作だけにとどまらず、子どもたちの能力をより深部から耕すカリキュラムに基づき、未来に役立つ学びを提供していきます。</p>
        </div>
        </div>
      </div>
      {/* カリキュラム ステモン教育コース / 開発者への想い */}
      {/* <Curriculum /> */}

      {/* 授業の流れ */}
      <LessonFlow />

      {/* 保護者からの声 */}
      <ParentVoice />
    </Main>
    
  );
}
export default Lesson;